@import 'styles/mixins';
@import 'styles/blaze/mixins';

.articleLoadingPreview {
  border-radius: 20px 20px 0 0;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  box-shadow: 0px 20px 80px 0px var(--dark-10);
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 950px;
  height: 100%;
  margin-top: 120px;
  padding: 100px 75px 0 75px;

  :global .ant-skeleton-paragraph {
    li {
      border-radius: 90px !important;
      margin-top: 18px !important;
    }
  }

  .title {
    :global {
      li:last-child {
        width: 450px !important;
        height: 40px !important;
      }
    }
  }

  .first {
    :global {
      li:last-child {
        width: 350px !important;
      }
    }
  }

  .second {
    :global {
      li:last-child {
        width: 540px !important;
      }
    }
  }

  .third {
    :global {
      li:last-child {
        width: 400px !important;
      }
    }
  }
}
